export default __webpack_public_path__ + "static/media/icon_artifact_large_orange.2f98135d.svg";